import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {ContactEntityModel} from "../contact-entity.model";
import {AbstractEditPage} from "../../framework/entity/edit/edit-page/abstract-edit-page";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-contact-edit-page",
    templateUrl: "./contact-edit-page.component.html",
    providers: [provideEntityModel(ContactEntityModel)]
})
export class ContactEditPageComponent extends AbstractEditPage {

    constructor(public model: ContactEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }
}
